module.exports = __webpack_public_path__ + "img/bs.7e45e7fe.svg";